import FormFieldText from "../components/FormFieldText.vue";
import FormFieldTextarea from "../components/FormFieldTextarea.vue";
import FormFieldCheckboxGroup from "../components/FormFieldCheckboxGroup.vue";
import FormFieldRadio from "../components/FormFieldRadio.vue";
import FormFieldSelect from "../components/FormFieldSelect.vue";
import FormFieldHidden from "../components/FormFieldHidden.vue";
import FormFieldRecaptcha from "../components/FormFieldRecaptcha.vue";
import FormFieldDatepicker from "../components/FormFieldDatepicker.vue";
export const fieldComponents = {
  text: FormFieldText,
  number: FormFieldText,
  phone: FormFieldText,
  email: FormFieldText,
  password: FormFieldText,
  textarea: FormFieldTextarea,
  checkbox: FormFieldCheckboxGroup,
  checkbox_group: FormFieldCheckboxGroup,
  radio: FormFieldRadio,
  select: FormFieldSelect,
  hidden: FormFieldHidden,
  recaptcha: FormFieldRecaptcha,
  date: FormFieldDatepicker
};
